import React from "react";

import ContactInfo from "./components/ContactInfo";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("xs")]: {
      width:'90%'
  }
  },

}))

export default function Index() {

  const classes = useStyles()

  return (
    <div className={classes.root}>
      <ContactInfo />
    </div>
  )
}
